// src/redux/store.js
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { thunk } from 'redux-thunk'; // named import
import { authReducer } from './auth/authReducer';
import profileReducer from '../components/profile/profileReducer'; 
import  projectReducer  from '../components/projects/projectReducer'
import asyncReducer from '../async/asyncReducer';


const rootReducer = combineReducers({
  auth: authReducer,
  profile:profileReducer,
  projects:projectReducer,
  async:asyncReducer
});

// Redux DevTools setup
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);